import { render, staticRenderFns } from "./manage_projects.vue?vue&type=template&id=44fec6aa&scoped=true&"
import script from "./manage_projects.vue?vue&type=script&lang=ts&"
export * from "./manage_projects.vue?vue&type=script&lang=ts&"
import style0 from "./manage_projects.vue?vue&type=style&index=0&id=44fec6aa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fec6aa",
  null
  
)

export default component.exports